import { render, staticRenderFns } from "./TheTextDropdown.vue?vue&type=template&id=fc9e24c4&scoped=true"
import script from "./TheTextDropdown.vue?vue&type=script&lang=ts"
export * from "./TheTextDropdown.vue?vue&type=script&lang=ts"
import style0 from "./TheTextDropdown.vue?vue&type=style&index=0&id=fc9e24c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9e24c4",
  null
  
)

export default component.exports